import React from 'react'
import { size, some } from 'lodash'

import { areSameValue } from '../../core/utils'

import CheckboxWithHotKey from '../components/sections/checkbox-with-hotkey'

const createBatchUpdateTableColumn = ({
  allItemIds,
  focusedItemId,
  selectedItemIds,
  toggleSelectItemId,
  selectItemIdHotkey,
  toggleSelectAllItemIds,
  selectAllItemIdsHotkey,
  areHotkeysEnabled,
  isDisabled,
}) => ({
  title: (
    <CheckboxWithHotKey
      hotkey={selectAllItemIdsHotkey}
      hotkeyEnabled={areHotkeysEnabled}
      isChecked={size(allItemIds) === size(selectedItemIds)}
      onChange={() => toggleSelectAllItemIds()}
      isDisabled={isDisabled}
    />
  ),
  width: '30px',
  render: ({ id }) => (
    <CheckboxWithHotKey
      hotkey={selectItemIdHotkey}
      hotkeyEnabled={areHotkeysEnabled && id === focusedItemId}
      isChecked={some(selectedItemIds, selectedItemId =>
        areSameValue(selectedItemId, id),
      )}
      onChange={() => toggleSelectItemId(id)}
      isDisabled={isDisabled}
    />
  ),
})

export default createBatchUpdateTableColumn
